import { NumberedBadge } from '@piccolohealth/ui';
import React from 'react';
import { useParticipantNotesMinimalQuery } from '../../graphql/hooks/useParticipantQuery';
import { useAppContext } from '../../hooks/useAppContext';

interface Props {
  participantId: string;
}

export const ParticipantNotesBadge = (props: Props) => {
  const { participantId } = props;
  const { organization } = useAppContext();

  const { data } = useParticipantNotesMinimalQuery({
    organizationId: organization.id,
    participantId,
  });

  const notesTotal = data?.organization?.participant?.notes.pagination.total ?? 0;

  return <NumberedBadge count={notesTotal} />;
};
